export default __webpack_public_path__ + "static/media/cotations.7da77ce0.jpg";